export function computeWeight (tj, weight, row, id, than, oneweight, starprice, elsePrice) {
  // -------------- 先判断是否填写了完整信息 --------------
  if (!tj)
    return than.$message.error('请输入包裹体积。')
  if (!weight)
    return than.$message.error('请输入包裹重量。')
  if (!row)
    return than.$message.error('请先选择报价。')
  if (!id)
    return than.$message.error('请先选择物品。')

  elsePrice = parseFloat(elsePrice)
  starprice = parseFloat(starprice)
  oneweight = parseFloat(oneweight)
  // 物品单价附加费
  let goodsPric = row.wptype ? parseFloat(row.wptype[id].price) : 0

  // 计费重
  let totalWeight = 0

  // 材积重
  let volumeWeight = tj / row.cjxs

  // 实际价格
  let totalPrice = 0

  // 如果不存在物品附加费就归零
  if (!goodsPric) {
    goodsPric = 0
  }

  if (row.gs == 1 || row.gs == 2) {

    if (row.gs == 1) {
      // 取最大的重量
      totalWeight = Math.max(volumeWeight, weight);
      // 返回计费方式为全泡或百分比泡的重量
      totalWeight = compute_Weight(totalWeight, row.xzdw);
    }


    // 百分比泡
    if (row.gs == 2) {

      // 把抛百分比转换数字
      let paobfb = parseFloat(row.paobfb) * 0.01;

      // 判断材积重和实际重量的大小
      if (volumeWeight > weight) {
        //计费重
        totalWeight = (volumeWeight - weight) - ((volumeWeight - weight) * paobfb) + weight;
      } else {
        //实际重
        totalWeight = weight
      }
      totalWeight = compute_Weight(totalWeight, row.xzdw);
    }

    //重量判断是否小于首重
    if (totalWeight <= oneweight) {
      totalPrice = parseFloat(starprice) + (totalWeight * (goodsPric + elsePrice))

      // 返回
      return {
        tj,
        weight,
        dj: row.xzprice,
        fjf: goodsPric + elsePrice,
        totalWeight,
        xzdw: row.xzdw,
        additionPrice: 0,
        text: "【总价格 = " + starprice + e('首重价') + " + " + totalWeight * (goodsPric + elsePrice) + e('物品附加费') + " = " + totalPrice + '元 】',
        starpriceTexe: `【起步价=  ${starprice} ${e('初始起步价')} + （${oneweight} ${e('首重')} ）x ( ${goodsPric}  ${e('物品费')} + ${elsePrice} ${e('其他单价附加费')})】`,
        goodsText: `【物品附加费】`,
        starprice,
        totalPrice
      }

    } else {

      //续重价格
      let falg = true
      //区间单价
      let qj_price = 0;
      //区间续重单位
      let qj_xzdw = 0;

      for (const key in row.qjprice) {
        if (row.qjprice[key].min <= totalWeight && row.qjprice[key].max >= totalWeight) {
          falg = false
          qj_price = row.qjprice[key].price
          qj_xzdw = row.qjprice[key].xzdw
        }
      }
      if (falg) {
        qj_price = row.xzprice
        qj_xzdw = row.xzdw
      }


      let additionPrice = Math.ceil((Math.ceil(totalWeight - oneweight) / qj_xzdw) * (parseFloat(qj_price) + goodsPric + elsePrice));


      let starprice_1 = parseFloat(starprice) + (oneweight * (goodsPric + elsePrice))

      totalPrice = parseFloat(starprice_1) + additionPrice;

      return {
        tj,
        weight,
        dj: qj_price,
        fjf: goodsPric + elsePrice,
        totalWeight,
        xzdw: qj_xzdw,
        additionPrice,
        text: "【总价格: " + starprice_1 + e('首重价') + " + " + additionPrice + e('续重价') + " = " + totalPrice + '元 】',

        starpriceTexe: `【起步价：  ${starprice} ${e('初始起步价')} + [（${oneweight} ${e('首重')} / 1）x (${goodsPric}  ${e('物品费')}+${elsePrice} ${e('其他附加费')}) ] = ${starprice_1}】`,

        xzprice: `【续重价：[ (${(totalWeight)} ${e('计费重')}- ${(oneweight)} ${e('首重')})${e('向上取整')} / ${(qj_xzdw)} ${e('区间续重单位')}] x  (${(qj_price)} ${e('区间价格')} + ${(goodsPric)} ${e('物品费')} +  ${(elsePrice)} ${e('其他附加费')}) =${additionPrice}} 】`,

        starprice,
        totalPrice
      }
    }
  } else if (row.gs == 3) {
    //起方价
    let starprice = parseFloat(row.starprice);
    //续方价
    let weightprice = parseFloat(row.weightprice);
    // 总方数 = max(实际重量 / 重换算方数重量 , 实际方数)
    totalWeight = Math.max((weight / zjf), volume);
    // 获取是否需要续重
    let xfdw = Math.ceil((totalWeight - oneweight) / xzdw);
    // 续方单位取整
    xfdw = xfdw > 0 ? Math.ceil(xfdw) : 0;

    let xfprice = xfdw > 0 ? xfdw * (parseFloat(goodsPric) + weightprice) : 0;

    totalPrice = starprice + xfprice;
    return {

    }
  }
};

//-------------【 返回计费方式为全泡或百分比泡的重量 】-------------
export function compute_Weight (weight, xzdw) {
  weight = parseFloat(weight);
  if (parseFloat(xzdw) < 1) {
    let condition = weight - Math.round(weight);
    if (condition > parseFloat(xzdw)) {
      weight = Math.ceil(weight);
    } else if (condition < parseFloat(xzdw) && condition > 0) {
      weight = weight + parseFloat(xzdw);
    } else if (condition <= 0) {
      weight = Math.round(weight);
    } else if (condition == parseFloat(xzdw)) {
      weight = weight;
    }
  } else {
    weight = Math.ceil(weight);
  }
  return weight;
}

export function e (t) {
  return `<span class='priceExplain'>*${t}</span>`
}
